import React, { useEffect, useRef, useState } from "react";
import { Form as DhxForm } from "dhx-suite";
import { initialProductsList } from "../../store";

function getFormConfig(filterTags: string[]) {
    const config = [
        {
            type: "text",
            value: "Products",
            css: "header-label-text"
        }
    ] as any;

    initialProductsList.forEach(product => {
        if (product) {
            config.push({
                id: product,
                type: "checkbox",
                checked: filterTags.includes(product),
                label: product.charAt(0).toUpperCase() + product.slice(1),
                name: product,
                labelInline: true
            });
        }
    });

    return config;
}

interface ProductsFilterProps {
    filterTags: string[];
    onChange: (id: string) => void;
}

export const ProductsFilter = ({ filterTags, onChange }: ProductsFilterProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [form, setForm] = useState<DhxForm>();

    useEffect(() => {
        if (ref.current && !form) {
            const theForm = new DhxForm(ref.current, {
                padding: "0 0 0 32px",
                rows: getFormConfig(filterTags)
            });
            setForm(theForm);
        }

        if (form) {
            form.events.on("change", id => onChange(id));
            return () => form.events.detach("change");
        }

        return undefined;
    });

    useEffect(() => {
        if (form) {
            form.setConfig({
                padding: "0 0 0 32px",
                rows: getFormConfig(filterTags)
            });
        }
    }, [filterTags]);

    return <div className="st-products-filter" ref={ref}></div>;
};
